import { DataTableSortStatus } from 'mantine-datatable';

type GetSortStatusReturnType = DataTableSortStatus;

type GetSortStatusOptionsType = {
  sortValue: string;
  defaultAccessor: string;
  defaultDirection: DataTableSortStatus['direction'];
};

export const getSortStatus = ({
  sortValue,
  defaultAccessor,
  defaultDirection,
}: GetSortStatusOptionsType): GetSortStatusReturnType => {
  const [sortParam, orderParam] = sortValue.split(':') ?? [];
  const sort = sortParam ?? defaultAccessor;
  const order: DataTableSortStatus['direction'] =
    orderParam === 'asc' || orderParam === 'desc'
      ? orderParam
      : defaultDirection;

  return {
    columnAccessor: sort,
    direction: order,
  };
};
